/**
 * Giphy REST client. Port of flock-expo/src/services/giphy.ts
 * (expo-constants key source swapped for Vite env).
 */
export class GiphyRateLimitError extends Error {
  constructor() {
    super('Giphy rate limit exceeded');
    this.name = 'GiphyRateLimitError';
  }
}

const GIPHY_API_KEY = import.meta.env.VITE_GIPHY_API_KEY || '';
const BASE_URL = 'https://api.giphy.com/v1/gifs';

export interface GiphyImage {
  url: string;
  width: string;
  height: string;
}

export interface GiphyGif {
  id: string;
  title: string;
  images: {
    fixed_height: GiphyImage;
    fixed_height_still: GiphyImage;
    original: GiphyImage;
  };
}

export interface GiphyResponse {
  data: GiphyGif[];
  pagination: {
    total_count: number;
    count: number;
    offset: number;
  };
}

export async function searchGifs(query: string, offset = 0, limit = 20): Promise<GiphyResponse> {
  const params = new URLSearchParams({
    api_key: GIPHY_API_KEY,
    q: query,
    limit: String(limit),
    offset: String(offset),
    rating: 'pg',
    lang: 'en',
  });

  const res = await fetch(`${BASE_URL}/search?${params}`);
  if (res.status === 429) throw new GiphyRateLimitError();
  if (!res.ok) throw new Error(`Giphy search failed: ${res.status}`);
  return res.json();
}

export async function getTrendingGifs(offset = 0, limit = 20): Promise<GiphyResponse> {
  const params = new URLSearchParams({
    api_key: GIPHY_API_KEY,
    limit: String(limit),
    offset: String(offset),
    rating: 'pg',
  });

  const res = await fetch(`${BASE_URL}/trending?${params}`);
  if (res.status === 429) throw new GiphyRateLimitError();
  if (!res.ok) throw new Error(`Giphy trending failed: ${res.status}`);
  return res.json();
}
